// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lm-job-list{padding:calc(var(--global_spacing)) 0 var(--global_spacing) 0}.lm-job-list__headline{grid-column-end:span 12;grid-column-start:1;margin-bottom:2rem}@media(min-width:768px){.lm-job-list__headline{grid-column-end:span 8}}@media(min-width:1024px){.lm-job-list__headline{grid-column-end:span 6;margin-bottom:4rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
